import Sidebar from './Sidebar';
import { useUserStore } from '../store/userStore';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const user = useUserStore((state) => state.user);

  if (!user) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar
        user={{
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
        }}
      />
      <main className="flex-1">{children}</main>
    </div>
  );
}
